// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__35W63","select":"Header_select__34gCQ","clinic":"Header_clinic__1hPyP"};